"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
// if price is a number, it's in cents
var getNumericPrice = function (price) { return (typeof price === 'string' ? parseFloat(price) : price / 100); };
exports.default = (function (_a) {
    var e_1, _b;
    var selMainVariant = _a.selMainVariant, selAddOns = _a.selAddOns, selDiscountAddOns = _a.selDiscountAddOns, promotionalAddOns = _a.promotionalAddOns, selChoices = _a.selChoices;
    if (!selMainVariant)
        return '0';
    var promotionalVariants = promotionalAddOns ? promotionalAddOns.map(function (product) { return product.variants[0]; }) : [];
    var price = getNumericPrice(selMainVariant.price);
    try {
        for (var _c = __values(selAddOns.concat(selDiscountAddOns, promotionalVariants, selChoices || [])), _d = _c.next(); !_d.done; _d = _c.next()) {
            var variant = _d.value;
            price += getNumericPrice(variant.price);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // best to return a string, because javascript drops
    // trailing zeroes which will cause formatPrice to think it's in cents
    return price.toFixed(2);
});
